/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2019, Zumper
 * @description relatedListingsReducer
 */

import { payloadReducer } from '@zcode/reducers'
import type { RelatedListings } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLEAR_LISTABLES, ERROR_FETCHING, RECEIVE_LISTABLES } from './constants'
import type { ActionTypes } from './types'

export const relatedListingsReducer = combineReducers<RelatedListings, ActionTypes>({
  listables: handleActions<RelatedListings['listables'], ActionTypes>(
    {
      [RECEIVE_LISTABLES]: payloadReducer,
      [ERROR_FETCHING]: () => [],
      [CLEAR_LISTABLES]: () => [],
    },
    []
  ),
})
